/**
 * Verkleinert ein ausgewaehltes Bild auf ein quadratisches Profilbild.
 *
 * Das Ergebnis liegt als Datenadresse im Nutzerdatensatz und kommt bei jedem
 * Laden der Mannschaftsliste mit. Deshalb wird hier hart auf 128 Pixel
 * heruntergerechnet, statt dem Server eine Datei beliebiger Groesse zuzumuten.
 */
export async function toAvatarDataUrl(file: File, size = 128): Promise<string> {
  if (!file.type.startsWith('image/')) throw new Error('Das ist keine Bilddatei.');

  const bitmap = await createImageBitmap(file);
  const kante = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Das Bild konnte nicht verarbeitet werden.');
  // Mittiger Ausschnitt: ein Portraet soll nicht verzerrt werden.
  ctx.drawImage(
    bitmap,
    (bitmap.width - kante) / 2,
    (bitmap.height - kante) / 2,
    kante,
    kante,
    0,
    0,
    size,
    size,
  );
  bitmap.close();

  const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
  if (dataUrl.length > 80_000) throw new Error('Das Bild ist zu groß. Bitte ein einfacheres wählen.');
  return dataUrl;
}
